import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_my_card_body = _resolveComponent("my-card-body")!
  const _component_my_card = _resolveComponent("my-card")!

  return (_openBlock(), _createBlock(_component_my_card, { class: "mt-4 flex-1 d-flex flex-column" }, {
    header: _withCtx(() => [...(_cache[0] || (_cache[0] = [
      _createElementVNode("div", { class: "pa-4" }, " 七天活跃用户 ", -1)
    ]))]),
    default: _withCtx(() => [
      _createVNode(_component_my_card_body, { class: "flex-1 px-4" }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            ref: $setup.setRef,
            style: {"height":"100%"}
          }, null, 512)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}